/**
 * Set field to savedSearch
 * @param {Object} tree
 * @param {string} id
 * @param {string} fieldName
 * @param {*} fieldValue
 * @returns {Object} new tree
 */
export default function setField(tree, id, fieldName, fieldValue) {
  const matchesTarget = (savedSearch) => savedSearch._id === id || savedSearch.path === id;

  const handleSavedSearch = (savedSearch) => {
    if (savedSearch.nodes && savedSearch.nodes.length > 0) {
      savedSearch.nodes = savedSearch.nodes.map(handleSavedSearch);
    }
    /** Empty-group placeholders use Mongo `_id`; callers often key updates by `path`
     * (same as virtual groups where `_id === path`). */
    if (matchesTarget(savedSearch)) {
      if (Array.isArray(fieldName) && Array.isArray(fieldValue)) {
        /* In case we need to update multiple fields at once,
        e.g. when renaming we update both 'name' and 'isBusy' */
        const updatedFields = fieldName.reduce((acc, name, index) => {
          acc[name] = fieldValue[index];
          return acc;
        }, {});
        return {
          ...savedSearch,
          ...updatedFields,
        };
      }
      return {
        ...savedSearch,
        [fieldName]: fieldValue,
      };
    }
    return savedSearch;
  };

  return {
    favorites: handleSavedSearch(tree.favorites),
    personalSearches: handleSavedSearch(tree.personalSearches),
    teamSearches: handleSavedSearch(tree.teamSearches),
  };
}
